import React from "react";
import MetaTags from "react-meta-tags";
import { Container } from "reactstrap";



//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

const Dashboard2 = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> tccontrol | Dashboard</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"tccontrol"} breadcrumbItem={"Dashboard"} />

        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard2;
